<mat-card appearance="outlined" class="card">
  <div class="metrics-card-header">
    <mat-card-title [ngClass]="{ 'no-subtitle': !header.subtitle }">
      <span>{{ header.title.key | translate : header.title.params }}</span>
      @if (cardImage) {
        <img class="right-corner-icon" src="{{ cardImage }}" />
      }
    </mat-card-title>
    @if (header.subtitle) {
      <mat-card-subtitle>
        {{ header.subtitle.key | translate : header.subtitle.params }}
      </mat-card-subtitle>
    }
    <div class="split-card">
      <div class="left">
        @if (!hideTopStats && current) {
          @if (!!changes) {
            <glxy-number-with-change [changeInfo]="changes"></glxy-number-with-change>
          } @else {
            <div class="left current-value-text">-</div>
          }
          @if (currentAgeText) {
            <mat-card-subtitle>
              {{ currentAgeText }}
            </mat-card-subtitle>
          }
        }
      </div>
      <ng-content class="split-card" select="[header-content]"></ng-content>
    </div>
  </div>
  <div
    class="chart-container"
    [ngClass]="{
      'chart-container-full': cardSize === 'full',
      'chart-container-small': cardSize !== 'full'
    }"
    >
    <div class="chart-inner-container">
      <ng-content></ng-content>
    </div>
  </div>
  <div class="legend-container">
    <ng-content select="[chart-legend]"></ng-content>
  </div>
</mat-card>
